const customGtmIds: Types.PlainObject = {
  'bramuse.com': 'GTM-K2Z9T9Z'
}

export function isCustomGtmDomains(domain: string) {
  return [Object.getOwnPropertyNames(customGtmIds).includes(domain), customGtmIds[domain]]
}
